module.exports = __webpack_public_path__ + "img/portfolio-07.a7bcc917.jpg";